import { Component, Renderer2 } from "@angular/core";
import { ActivatedRoute} from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { BroadcastManager } from "../../../../_appCommon/base/BroadcastManager";
import { AppEventNames } from "../../../../_appCommon/base/Constants";
import { ControllerBase } from "../../../../_appCommon/base/ControllerBase";
import { PrescriptionDataService } from "../../../../_dataservices/PrescriptionDataService";

@Component({
  selector: 'app-client-case-prescriptions',
  templateUrl: './case-prescriptions.component.html',
  styleUrls: ['./case-prescriptions.component.css'],
  providers: [PrescriptionDataService]
})
export class CasePrescriptionsComponent extends ControllerBase
{
  public prescriptionsResponse = [];
  private caseId: number;
  public unsubscribe: Subject<boolean> = new Subject();

  constructor(protected route: ActivatedRoute, private prescriptionDataService: PrescriptionDataService, private renderer: Renderer2)
  {
    super();
  }

  ngOnInit(): void
  {
    this.route.paramMap.subscribe(params =>
    {
      this.caseId = +params.get('id');
      this.initializeBroadcast();
      this.getPrescriptionFiles();
    });
  }

  ngOnDestroy(): void
  {
    this.unsubscribe.next(true);
    this.unsubscribe.unsubscribe();
  }

  private initializeBroadcast(): void
  {
    BroadcastManager.Instance.on(AppEventNames.onUpdatePrescriptionFiles)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([response]) =>
      {
        this.getPrescriptionFiles();
      });
  }

  private getPrescriptionFiles(): void
  {
    if (this.caseId)
    {
      this.prescriptionDataService.getPrescriptionsByCaseId(this.caseId).subscribe((response: any) =>
      {
        this.prescriptionsResponse = response;
      }, (fail: any) =>
      {
        this.setWarningAlert(fail.error.message);
      });
    }
  }

  public downloadPrescription(url: string)
  {
    const link = this.renderer.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', url);
    link.setAttribute('download', `Prescripción.pdf`);
    link.click();
    link.remove();
  }
}
